import { v1ApiClient } from '@/services';

import type { FetchChartFeedbackByCell } from './types';

export type AnalyzeChartFeedbackPeakParams = FetchChartFeedbackByCell;

export type AnalyzeChartFeedbackPeakResponse = {
  text: string;
};

export const analyzeChartFeedbackPeak = async (
  workspace_alias: string,
  params: AnalyzeChartFeedbackPeakParams,
): Promise<AnalyzeChartFeedbackPeakResponse> => {
  const res = await v1ApiClient.post<AnalyzeChartFeedbackPeakResponse>(
    `/workspaces/${workspace_alias}/charts/change_drivers`,
    params,
  );

  return res.data;
};
